import React from 'react';
import '../scss/main.scss';

const HorizontalBarChart = ({data}) => {
	return (
		<div className="evaluation__bar">
			<div className="btn btn__primary-soft btn__rounded btn__md evaluation__bar-type">{data.type}</div>

			{data?.text && <div className="text-xl evaluation__bar-header">{data.text}</div> }
			<div className="bar__chart">
				<div className="bar__chart-bar" style={{ width: data.score + '%' }}>
					<span className="bar__chart-percentage">{data.score + '%'}</span>
				</div>
			</div>
			{data?.answer &&
				<div className="text-gray-700 text-sm">
					<b className="text__primary">Answer:</b>
					<div>{data.answer}</div>
				</div>
			}
			{data?.explanation &&
				<div className="text-gray-700 text-sm mtop--10">
					<b className="text__primary">Why {data.score}% ?</b>
					<div>{data.explanation}</div>
				</div>
			}
			{data?.skills &&
				<div className="text-gray-700 text-sm mtop--10">
					<b className="text__primary">Skills tested:</b>
					<div>
						{data?.skills.map((skill, idx) => {
							return (
								<span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2" key={`skill_${idx}`}>
									#{skill.text}
								</span>
							)
						})}
					</div>
				</div>
			}
		</div>
	);
};

export default HorizontalBarChart;
